const lookupControlTester = (uiSchema) => {
  return uiSchema.specializedType && uiSchema.specializedType === 'Lookup' ? 7 : 0
}

export default lookupControlTester